import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"slides-wide"} maskId="square-filled-radius-0-stroke-1-IconSlidesWide"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H18V8H22V20H6V16H2V4ZM6 15H3V5H17V8H6V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSlidesWide;
